import { memo } from 'react';

import clsx from 'clsx';

import HourLegend from '@calendar/components/HourLegend';
import MonthList from '@calendar/components/MonthList';
import MonthSelector from '@calendar/components/MonthSelector';
import TimeslotLengthSelector from '@calendar/components/TimeslotLengthSelector';
import useHandleSyncScroll from '@calendar/hooks/useHandleSyncScroll';
import TutorialLegend from '@event/components/TutorialModal';
import { useTutorialStore } from '@event/store/useTutorialStore';
import useClientStore from '@utils/hooks/useClientStore';
import useGetDevice from '@utils/hooks/useGetDevice';

const Calendar = () => {
  const { isMobile, isDesktop } = useGetDevice();
  const { firstRef, secondRef } = useHandleSyncScroll(true);

  const tutorialStore = useClientStore(useTutorialStore, (state) => state);

  const isTutorialEventTimeSlots =
    tutorialStore?.tutorialStep === 'eventTimeSlots' &&
    tutorialStore?.isTutorialActive;

  return (
    <div className="mt-8 flex w-full flex-wrap justify-center rounded-[32px] bg-brand-white-100 lg:rounded-[80px]">
      <div
        className={clsx(
          'flex w-full flex-row flex-wrap items-center rounded-t-[32px] border-b border-solid border-brand-gray-300 bg-brand-white-100 pb-4 pt-[20px] md:max-w-[940px] lg:rounded-t-[6px]',
          !isTutorialEventTimeSlots ? 'sticky top-0 z-10' : 'relative',
        )}
      >
        {isTutorialEventTimeSlots && (
          <TutorialLegend
            textBubble="V tabulce vyklikejte termíny. Pak už jen vytvořte událost a nasdílejte přátelům."
            textHeadingCounter="5/5"
            textHeading="Vyberte termíny."
            onSubmit={() => tutorialStore.setIsTutorialActive(false)}
            className="bottom-[202px] left-2 lg:bottom-[128px] lg:left-0"
          />
        )}
        {isMobile && (
          <div
            className={clsx(
              'z-30 w-full overflow-x-auto px-4 pb-6 pt-2 lg:hidden',
              isTutorialEventTimeSlots && 'rounded-t-[16px] bg-brand-white-100',
            )}
          >
            <TimeslotLengthSelector />
          </div>
        )}
        <div
          className={clsx(
            'flex w-full flex-row px-4 py-2',
            isTutorialEventTimeSlots &&
              'z-20 rounded-b-[16px] bg-brand-white-100 lg:rounded-[16px]',
          )}
        >
          <MonthSelector monthListRef={secondRef} />
          {isDesktop && (
            <div className="ml-auto hidden lg:block">
              <TimeslotLengthSelector />
            </div>
          )}
        </div>
        <div
          className="mx-2 w-full overflow-x-auto scrollbar-hide md:mx-0 md:max-w-[940px] lg:overflow-x-hidden"
          ref={firstRef}
        >
          <HourLegend />
        </div>
      </div>
      <div
        className="mx-2 mt-2 w-full overflow-x-auto md:mx-0 md:max-w-[940px] lg:overflow-x-visible"
        ref={secondRef}
      >
        <MonthList />
      </div>
    </div>
  );
};

export default memo(Calendar);
